var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4300WA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,14.117647%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.998047 0.998047 L 34.001953 0.998047 L 34.001953 34.001953 L 0.998047 34.001953 Z M 0.998047 0.998047 ",
    transform: "matrix(0.857143,0,0,0.857143,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,14.117647%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 29.499349 L 32.999349 29.499349 ",
    transform: "matrix(0.857143,0,0,0.857143,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,14.117647%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 5.500651 L 32.999349 5.500651 ",
    transform: "matrix(0.857143,0,0,0.857143,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,14.117647%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 5.500651 0.998047 L 5.500651 34.001953 ",
    transform: "matrix(0.857143,0,0,0.857143,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,14.117647%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 29.499349 0.998047 L 29.499349 34.001953 ",
    transform: "matrix(0.857143,0,0,0.857143,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,14.117647%,27.843137%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 17.750651 0.715495 L 17.750651 34.284505 ",
    transform: "matrix(0.857143,0,0,0.857143,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4300WA);
export default __webpack_public_path__ + "static/media/4300W-a.7f2dfb9e2d3eef94908e586a855b645a.svg";
export { ForwardRef as ReactComponent };